export const SERVER_SECURE_CONSTANTS_CACHE_KEY = "server-secure-constants";
export const SERVER_PUBLIC_CONSTANTS_CACHE_KEY = "server-public-constants";
